import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  Filter,
  TextInput,
  CreateButton
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";
import { styles } from "./styles";
import "./index.css";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";

import { CollectionCreate as create, CollectionEdit as edit } from "./Create";

const CollectionsActions = ({ resource, basePath, refresh }) => (
  <CardActions
    style={styles.cardActionStyleSmall}
    className="collections-actions"
  >
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);

const CollectionsFilter = ({ ...props }) => (
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn
    />
  </Filter>
);

export const CollectionCreate = create;
export const CollectionEdit = edit;

export const CollectionsList = props => (
  <List
    {...props}
    actions={<CollectionsActions />}
    filters={<CollectionsFilter />}
    title={
      <IconTitle icon="collections" title={"resources.collections.title"} />
    }
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField label="resources.collections.fieldList.name" source="name" />
      <DateField
        label="resources.collections.fieldList.create_at"
        source="created_at"
      />
      <EditButton label="" style={{ textAlign: "right" }} />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/collections/index.js